var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PostButton"}},[_c('v-btn',{attrs:{"fab":"","dark":"","large":"","color":"red","to":{name: 'Edit', params: {obj: {mode: 'new'}}}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf149eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PostButton.vue
// module id = null
// module chunks = 